import { IEstimateFormData, IFormItem } from '~/store/slices/estimateFormSlice';
import { IEstimateSerializer } from '~/types/estimate';

export const getAmount = (itemData: IFormItem) => {
  const qty = parseFloat(itemData.quantity) || 0;
  const price = parseFloat(itemData.price) || 0;
  return qty * price;
};

export const getTotalAmountDetails = (formData: IEstimateFormData) => {
  let subTotal = 0;
  let discount = parseFloat(formData.discount) || 0;

  // Sub Total
  for (const eachItem of formData.items) {
    subTotal += getAmount(eachItem);
  }

  // Discount
  if (formData.discountType === 'percent') {
    discount = (subTotal * discount) / 100;
  }

  const totalAfterDiscount = subTotal - discount;

  // Tax
  let tax = parseFloat(formData.tax) || 0;
  if (formData.taxType === 'percent') {
    tax = (totalAfterDiscount * tax) / 100;
  }

  const totalAfterTax = totalAfterDiscount + tax;

  // Shipping
  let shipping = parseFloat(formData.shipping) || 0;
  if (formData.shippingType === 'percent') {
    shipping = (totalAfterTax * shipping) / 100;
  }

  const totalAmount = totalAfterTax + shipping;

  return { subTotal, discount, tax, shipping, totalAmount };
};

export const serializeEstimateData = (data: IEstimateSerializer): IEstimateFormData => {
  const estimateItems = [];
  const rawItems = data.items;
  for (let index = 0; index < rawItems.length; index++) {
    const estimateItem = rawItems[index];
    estimateItems.push({
      id: estimateItem.id,
      description: estimateItem.description,
      sku: estimateItem.sku,
      quantity: estimateItem.quantity.toString(),
      price: estimateItem.price.toString(),
    });
  }

  return {
    estimateUuid: data.estimate_uuid,
    estimateNumber: data.estimate_number,
    logoUrl: data.logo_url,
    estimateDate: data.estimate_date,
    dueDate: data.due_date,
    poNumber: data.po_number,
    notes: data.notes,
    terms: data.terms,
    currency: data.currency,
    discount:
      data.discount_type === 'percent'
        ? data.discount_percentage.toString()
        : data.discount_amount.toString(),
    discountType: data.discount_type,
    shipping:
      data.shipping_type === 'percent'
        ? data.shipping_percentage.toString()
        : data.shipping_amount.toString(),
    shippingType: data.shipping_type,
    tax: data.tax_type === 'percent' ? data.tax_percentage.toString() : data.tax_amount.toString(),
    taxType: data.tax_type,
    sellerDetails: {
      companyName: data.seller_company_name,
      address_line_1: data.seller_address_line_1,
      address_line_2: data.seller_address_line_2,
      city: data.seller_city,
      state: data.seller_state,
      postal_code: data.seller_postal_code,
      country: data.seller_country,
      email: data.seller_email,
      phone: data.seller_phone,
      website: data.seller_website,
    },
    buyerDetails: {
      companyName: data.buyer_company_name,
      address_line_1: data.buyer_address_line_1,
      address_line_2: data.buyer_address_line_2,
      city: data.buyer_city,
      state: data.buyer_state,
      postal_code: data.buyer_postal_code,
      country: data.buyer_country,
      email: data.buyer_email,
      phone: data.buyer_phone,
      website: data.buyer_website,
    },
    shippingDetails: {
      companyName: data.shipping_company_name,
      address_line_1: data.shipping_address_line_1,
      address_line_2: data.shipping_address_line_2,
      city: data.shipping_city,
      state: data.shipping_state,
      postal_code: data.shipping_postal_code,
      country: data.shipping_country,
      email: data.shipping_email,
      phone: data.shipping_phone,
      website: data.shipping_website,
    },
    template_id: data.template_id,
    isShippingUnique: data.is_shipping_unique,
    logo: null,
    items: estimateItems,
    client_uuid: data.client_uuid,
    isShippingEnabled: data.is_shipping_enabled,
  };
};
